<template>
  <section id="subs" v-loading="loading">
    <slot name="header">
      <header>
<!--        <small>Subscription</small>-->
        <h1>Subscribe to NAVLIN DAILY</h1>
<!--        <p>NAVLIN DAILY offers multiple subscription plans for Individuals and Teams. For Enterprise Access, please reach out to our sales team for more information!</p>-->
      </header>
    </slot>
<!--    <ul>-->
<!--      <li>-->
<!--        <input  id="billed-quarterly" name="billed"-->
<!--                value="quarterly" type="radio">-->
<!--        <label @click="type='INDIVIDUAL'" :class="type == 'INDIVIDUAL'?'active':''"-->
<!--               for="billed-quarterly">Individual Membership</label>-->
<!--        <span class="switch" @click="type = (type== 'INDIVIDUAL'?'TEAM':'INDIVIDUAL')"-->
<!--              :class="type == 'INDIVIDUAL'?'switch-idv':''"></span>-->
<!--      </li>-->
<!--      <li>-->
<!--        <input  id="billed-anually" name="billed" value="anually" type="radio" checked>-->
<!--        <label @click="type='TEAM'" for="billed-anually"-->
<!--               :class="type == 'INDIVIDUAL'?'':'active'">Team Membership</label>-->
<!--      </li>-->
<!--    </ul>-->
    <div class="individual-plan" v-if="planInfo[type] && planInfo[type].length>0 && type=='INDIVIDUAL'">
      <section class="section-price">
        <dt class="plan-title" v-html="planIntroMap[individualPlan.key].titleHtml || planIntroMap[individualPlan.key].title"></dt>
        <dd class="plan-price">${{ moneyFormat(individualPlan.price) }}</dd>
        <dd v-html="planIntroMap[individualPlan.key].desc"></dd>
      </section>
      <section class="line"></section>
      <section class="section-handle">
        <div class="plan-intro">Annual subscription renews at <br>
          <b>$199 USD</b> after the first year of service</div>
        <dd>
          <a class="button solid darkblue" href="javascript:;" @click="checkoutNow(individualPlan.key)">Subscribe Now</a>
        </dd>
      </section>
    </div>
<!--    <Swiper :modules="modules" -->
<!--            :slides-per-view="2"-->
<!--            :space-between="25" :autoHeight="true"-->
<!--            :pagination="{ clickable: true }"-->
<!--            :simulateTouch="true"-->
<!--            :breakpoints="{-->
<!--                  0: {-->
<!--                    slidesPerView: 1,-->
<!--                    spaceBetween: 0,-->
<!--                  },-->
<!--                  1024: {-->
<!--                    slidesPerView: 1,-->
<!--                    spaceBetween: 40,-->
<!--                  },-->
<!--                }">-->
<!--      <template v-for="item in planInfo[type]" :key="item.key">-->
<!--        <SwiperSlide v-if="planIntroMap[item.key] && item.status">-->
<!--          -->
<!--        </SwiperSlide>-->
<!--      </template>-->
<!--    </Swiper>-->

    <Swiper :modules="modules" class="w" v-if="planInfo[type] && planInfo[type].length>0 && type=='TEAM'"
            :slides-per-view="3"
            :space-between="25" :autoHeight="true"
            :pagination="{ clickable: true }"
            :simulateTouch="true"
            :breakpoints="{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                }">
      <template v-for="item in planInfo[type]" :key="item.key">
        <SwiperSlide v-if="planIntroMap[item.key] && item.status">
          <section>
              <dt v-html="planIntroMap[item.key].titleHtml || planIntroMap[item.key].title"></dt>
              <dd>${{ moneyFormat(item.price) }}</dd>
              <dd v-html="planIntroMap[item.key].desc"></dd>
              <dd>
                <a class="button solid darkblue" href="javascript:;" @click="checkoutNow(item.key)">Select Plan</a>
              </dd>
          </section>
        </SwiperSlide>
      </template>
    </Swiper>
    <slot name="footer">
      <p>Are you a student or require enterprise access for your organization? Contact us for more information!</p>
      <router-link to="/contactUs" class="button lg bordered darkblue">Contact NAVLIN DAILY</router-link>
    </slot>
  </section>
</template>
<script>
  // import Swiper core and required components
  import {Navigation, Pagination, Scrollbar, A11y, EffectFade} from 'swiper';
  // Import Swiper Vue.js components
  import { Swiper, SwiperSlide } from 'swiper/vue';
  // Import Swiper styles
  import 'swiper/css';
  import 'swiper/css/navigation';
  import 'swiper/css/pagination';
  import 'swiper/css/scrollbar';

  import { planIntroMap } from "@/utils/mapData";

  export default {
    components: {
      Swiper,
      SwiperSlide,
    },
    computed:{
      isLogin(){
        return this.$store.state.userInfo.username
      },
      individualPlan(){
        return this.planInfo.INDIVIDUAL[0] || {}
      },
    },
    data() {
      return {
        type:'INDIVIDUAL',  // INDIVIDUAL  TEAM
        key:'',
        planInfo:{
          INDIVIDUAL:[],
          TEAM:[],
        },
        loading:false,
        planIntroMap,
        modules: [Navigation, Pagination, Scrollbar, A11y, EffectFade]
      }
    },
    mounted() {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://js.stripe.com/v3/')
      document.head.appendChild(recaptchaScript)
      this.$http.get('/api/stripe/config').then(res=>{
        this.key = res.publishableKey
      }).then(()=>{
        let price = this.$route.query.plan
        price && this.checkoutByPrice(price)
      })
      this.$http.get('/api/license/plan').then(res=>{
        this.planInfo = {...res}
      })
    },
    methods: {
      async checkoutNow(priceKey){
        // this.$message.error('Service paused')
        // console.log(priceKey);
        // if note login redirect to login page
        if(!this.isLogin){
          await this.$router.push(`/register?from=/subscribe?plan=${priceKey}`)
          return
        }
        this.checkoutByPrice(priceKey)
      },
      async checkoutByPrice(price){
        this.loading = true
        try {
          if(!window.Stripe){
            await fetch('https://js.stripe.com/v3/')
          }
          if(!this.key){
            let keyObj = await this.$http.get('/api/stripe/config')
            this.key = keyObj.publishableKey
          }
          let sessionObj = await this.$http.post('/api/license/checkout',{
            price,
          })
          let stripe = await window.Stripe(this.key)
          console.log(stripe,sessionObj);
          stripe.redirectToCheckout({ sessionId: sessionObj.sessionId })
          this.loading = false
        }catch (e) {
          this.loading = false
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "../scss/var";


  .button {
    --color-clickable-svg-static: #F1F5FF;
    --color-clickable-svg-hover: #F1F5FF;
    flex-shrink: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0 1.6rem;
    height: 42px;
    font-weight: 700;
    font-size: 1.6rem;
    border-radius: 3px;
    text-align: center;
  }


  .button.lg {
    font-size: 1.6rem;
    height: 54px;
    border-radius: 5px;
  }


  /*  solid  */

  :where(.button).solid {
    background-color: var(--color-background-static);
  }

  .button:is(:hover, :focus, .active).solid {
    background-color: var(--color-background-hover);
  }


  /*  solid darkblue  */

  .button.solid.darkblue {
    --color-background-static: var(--color-pri-blue3);
    --color-background-hover: var(--color-sec-blue1);
    color: #fff;
  }


  /*  solid orange  */

  .button.solid.orange {
    --color-background-static: var(--color-sec-orange);
    --color-background-hover: var(--color-sec-blue1);
    color: #fff;
  }


  /*  solid black  */

  .button.solid.black {
    --color-background-static: #00214D;
    --color-background-hover: #4988B5;
    color: #fff;
  }


  /*  solid blue  */

  .button.solid.blue {
    --color-background-static: var(--color-blue1);
    --color-background-hover: #2D9CDB;
    color: #fff;
  }


  /*  solid deepblue  */

  .button.solid.deepblue {
    --color-background-static: var(--color-pri-blue1);
    --color-background-hover: #2D9CDB;
    color: #fff;
  }

  /*  bordered  */

  :where(.button).bordered {
    color: var(--color-text-static);
    background-color: transparent;
    border: 1px solid var(--color-border-static);
  }

  .button:is(:hover, :focus, .active).bordered {
    color: var(--color-text-hover, var(--color-text-static));
    background-color: var(--color-background-hover);
    border-color: var(--color-border-hover, var(--color-border-static));
  }


  /*  bordered white  */

  .button.bordered.white {
    --color-text-static: #fff;
    --color-background-hover: #2D9CDB;
    --color-border-static: #fff;
    --color-border-hover: #2D9CDB;
  }


  /*  bordered darkblue  */

  .button.bordered.darkblue {
    --color-text-static: var(--color-pri-blue3);
    --color-text-hover: #fff;
    --color-background-hover: var(--color-pri-blue3);
    --color-border-static: var(--color-pri-blue3);
  }

  #subs {
    position: relative;
    z-index: 1;
    padding: 84px var(--padding-inline-center-content) 129px;
    overflow: hidden;
    text-align: center;
    .individual-plan{
      max-width: 675px;
      margin: 32px auto 0;
      display: flex;
      align-items: center;
      background-color: #fff;
      border: 1px solid #D5E5F2;
      padding: 36px 58px;
      .line{
        width: 0;
        height: 140px;
        margin: 0 50px;
        border-left: 1px solid #EBF7FF;
      }
      .plan-title{
        justify-content: center;
        margin-right: 0;
      }
      .plan-price{
        font-size: 82px;
        margin: 8px auto;
      }
      .section-price{
        text-align: center;
        min-width: 200px;
        flex: 4;
      }
      .section-handle{
        flex: 5;
      }
      .plan-intro{
        font-size: 14px;
        line-height: 24px;
        text-align: left;
        color: #435B6F;
      }
      .button{
        margin-top: 20px;
        height: 56px;
      }
    }
  }

  #subs > .button {
    margin-top: 2.2rem;
    min-width: 236px;
  }

  #subs > header {
    text-align: center;
  }

  #subs header > small {
    color: var(--color-pri-blue3);
    font-weight: 700;
    font-size: 1.8rem;
    line-height: 1.364;
  }

  #subs header h1  {
    margin-top: 1rem;
    font-size: 3.8rem;
    line-height: 1.4;
  }

  #subs > header > p {
    margin: 6px auto 0;
    max-width: 503px;
    font-size: 1.4rem;
    line-height: 1.75;
    color: var(--color-body);
  }

  #subs > ul {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 3.9rem 0 34px;
    height: 34px;
  }

  #subs > ul > li:nth-child(1) {
    position: relative;
    display: flex;
    align-items: center;
    label{
      text-align: right;
    }
  }

  #subs > ul li:nth-child(1)::after {
    content: "";
    margin: 0 10px;
    width: 65px;
    height: 34px;
  }

  #subs li > input {
    position: absolute;
    left: -5000px;
  }

  #subs li > label {
    cursor: pointer;
    font-weight: 700;
    font-size: 12px;
    transition: color 200ms;
    width: 150px;
    display: inline-block;
    text-align: left;
    &.active{
      color: var(--color-pri-blue3);
    }
  }

  #subs li > label:hover {
    color: $baseDeep;
  }

  #subs .switch {
    position: absolute;
    top: 0;
    right: 10px;
    width: 65px;
    height: 34px;
    cursor: pointer;
    background-color: $baseDeep;
    border-radius: 17px;
  }

  #subs .switch::before {
    content: "";
    position: absolute;
    top: 3px;
    right: 3px;
    width: 28px;
    height: 28px;
    background-color: #FFFEFE;
    border-radius: 14px;
    transition: transform 200ms;
  }

  #subs .switch-idv::before {
    transform: translateX(-31px);
  }

  #subs > .w {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0 auto;
    max-width: 1076px;
    padding-left: 5px;
  }

  #subs > .w::before {
    content: "";
    margin-left: -15px;
  }

  #subs .w section {
    padding: 29px;
    width: 332px;
    background-color: #fff;
    border: 1px solid #D5E5F2;
    border-radius: 3px;
    transition-property: background-color, border-color;
    transition-duration: 200ms;
    margin: 0 auto;
    text-align: left;
  }



  #subs dl:not(.clone) > div,
  #subs dl.clone .slick-slide {
    display: flex;
    flex-direction: column;
    padding: 29px;
    width: 100%;
    max-width: 330px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #D5E5F2;
    border-radius: 3px;
  }

  #subs dl:not(.clone) > div:first-child:nth-last-child(3),
  #subs dl:not(.clone) > div:first-child:nth-last-child(3) ~ div { /* where there are 3 plans */
    width: 30.84113%;
  }

  #subs dl:not(.clone) > div:first-child:nth-last-child(2),
  #subs dl:not(.clone) > div:first-child:nth-last-child(2) + div { /* where there are 2 plans */
    width: 48.13085%;
  }

  #subs dt {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-right: 20px;
    color: #0F2542;
    font-weight: 700;
    font-size: 1.8rem;
    line-height: 1.7;
  }

  #subs dt > small,
  #subs dt::after {
    position: relative;
    left: 20px;
    flex-shrink: 0;
    margin-left: auto;
    padding: 7px 11px;
    color: #1C75BC;
    font-size: 1.2rem;
    line-height: 1.2;
    background-color: #EAF6FF;
    border-radius: 14px;
  }

  #subs dt::after {
    content: "|";
    position: static;
    visibility: hidden;
    margin-left: 0;
    padding-right: 0;
    padding-left: 0;
    width: 0;
    overflow: hidden;
  }

  #subs dt + dd {
    margin: 3.3rem 0 0.7rem;
    color: #0F2542;
    font-weight: 800;
    font-size: 4.6rem;
  }

  #subs dt + dd ~ dd {
    color: var(--color-gray);
    font-size: 1.6rem;
    line-height: 1.7;
    transition: color var(--trans-dur);
  }

  #subs :nth-last-child(2) + dd {
    margin-top: auto;
  }

  #subs dd > .button {
    margin-top: 45px;
    width: 100%;
    height: 46px;
  }

  #subs > p {
    margin: 3.7rem auto 0;
    max-width: 1070px;
    font-size: 1.8rem;
    line-height: 1.75;
  }

  #subs > .button {
    margin-top: 2.2rem;
    min-width: 236px;
  }


  #subs section > ul {
    margin-top: 25px;
  }

  #subs section li {
    position: relative;
    padding-left: 29px;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.75;
    transition: color 200ms;
  }

  #subs section li + li {
    margin-top: 10px;
  }

  #subs section:hover li {
    color: #fff;
  }

  #subs section li > .ico-check-circle {
    --circle-color: #00D1EF;
    --check-color: #1C75BC;
    position: absolute;
    top: 0.15em;
    left: 0;
    width: 18px;
    height: 18px;
  }

  #subs section:hover li > .ico-check-circle {
    --circle-color: #94F2FF;
    --check-color: #fff;
  }

  #subs > .w::after {
    content: "";
    margin-right: -15px;
  }

  #subs .clone {
    display: none;
  }
  .swiper-pagination{
    display: none;
  }

  .swiper-pagination-bullet-active{
    background: $light;
  }

  #subs dd > strong {
    color: #0F2542;
  }
  #subs > p {
    margin: 3.7rem auto 0;
    max-width: 1070px;
    font-size: 1.8rem;
    line-height: 1.75;
  }


  /*  2. responsive (1023px)
  -------------------------------------------------------*/

  @media (max-width: 1023px) {

    /*  1.1. Choose Your Plan  */

    #subs {
      padding-bottom: 46px;
      .swiper{
        padding-bottom: 30px;
      }
      .swiper-slide{
        display: block;
      }
      .swiper-pagination{
        bottom: 1px;
      }
      .swiper-pagination .swiper-pagination-bullet:not(.swiper-pagination-bullet-active){
        background-color: rgba(4, 27, 65, 0.25);
        opacity: 1;
      }
    }



    #subs > p {
      margin-top: 13px;
    }

    #subs > ul {
      margin-top: 43px;
    }

    #subs > .w {
      margin-right: -15px;
      margin-left: -15px;
      padding-left: 0;
      justify-content: center;
      align-items: center;
    }

    #subs .w section {
      /*display: none;*/
      max-width: 100%;
      margin: 0 auto;
    }

    #subs .clone {
      display: block;
      margin: 0 auto;
      width: 360px;
      max-width: 100%;
    }

    #subs .w-slide {
      outline-width: 0;
    }

    .slick-dots {
      display: flex;
      justify-content: center;
      padding-top: 10px;
    }

    .slick-dots > li {
      margin: 10px 5px 0;
    }

    .slick-dots li > button {
      width: 10px;
      height: 10px;
      font-size: 0;
      border-radius: 50%;
      background-color: #EBF7FF;
      transition: background-color 200ms;
    }

    .slick-dots li              > button:hover,
    .slick-dots li              > button:focus,
    .slick-dots li.slick-active > button {
      background-color: $light;
    }
    .swiper-pagination{
      display: block;
      bottom: 5px;
    }

  }



  /*  3. responsive ( 767px)
  -------------------------------------------------------*/

  @media (max-width:  767px) {
    .individual-plan{
      flex-direction: column;
      .line{
        display: none;
      }
    }

    /*  1.1. Choose Your Plan  */

    #subs {
      padding-top: 21px;
      padding-bottom: 21px;
    }

    #subs::before {
      content: none;
    }

    #subs header > small {
      font-size: 1.6rem;
    }

    #subs header > h1 {
      font-size: 2.4rem;
    }

    #subs > ul {
      margin-top: 1.8rem;
      margin-bottom: 20px;
    }

    #subs > p {
      margin-top: 2.1rem;
      font-size: 1.4rem;
      line-height: 1.7;
    }

    #subs > .button {
      min-width: 330px;
    }

    .slick-dots {
      padding-top: 6px;
    }
    .swiper-pagination{
      display: block;
      bottom: 5px;
    }

  }

</style>
